<template>
	<div>
		<!-- <div class="col-m-2"> -->
		<div>
			<b-form-checkbox
			size="sm"
			id="checkbox_auto_refresh"
			v-model.number="auto_refresh"
			name="checkbox_auto_refresh"
			value="1"
			unchecked-value="0"
			>
			自动刷新
			</b-form-checkbox>
		</div>
			<div>
				<b-form-datepicker size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked($event)" v-model="date1" class="mb-1" today-button close-button locale="zh"></b-form-datepicker>
			</div>
		
			<b-table :small="true" :busy="isBusy" :items="stocks" :fields="fields" :style="rowClass">
				<template #table-busy>
					<div class="text-center text-danger my-2">
						<b-spinner class="align-middle"></b-spinner>
						<strong>Loading...</strong>
					</div>
				</template>
				<!-- A custom formatted column -->
				<template #cell(px_change_rate)="data">
					<div :style="getPercentStyle(data.value)">{{ data.value }}</div>
				</template>
				<template #cell(rank_diff)="data">
					<div :style="getPercentStyle(data.value)">{{ data.value }}</div>
				</template>
				<template #cell(symbol_name)="data">
					<div class="cursor-pointer" @click="p_show_kline(data.item.symbol_code)">{{ data.value }}</div>
				</template>
				<template #cell(symbol_code)="data">
					<div class="cursor-pointer" @click="p_show_kline(data.value)">{{ data.value }}</div>
				</template>
			</b-table>
		<!-- </div> -->
		<!-- <div class="col-9"></div> -->
	</div>
</template>

<script>
	import moment from 'moment';
	import {
		request_zzquant
	} from "network/request.js"

	export default {
		data() {
			const today = moment().format('YYYY-MM-DD');
			return {
				date1: today,
				stocks: [],
				isBusy: true,
				fields: [
					{
						key: 'rank',
						sortable: true
					},
					{
						key: 'rank_diff',
						label: 'diff',
						sortable: true,
					},
					{
						key: 'symbol_name',
						label: 'symbol',
						// sortable: true,
					},{
						key: 'symbol_code',
						label: 'code',
						sortable: false,
						// formatter: (value, key, item) => {
						// 	return item.symbol_name
						// }
					},{
						key:'px_change_rate',
						label: 'pct',
						sortable: true,
						// formatter: (value) => {
						// 	return '<span style="'+this.getPercentColor(value)+'">'+value+'</span>'
						// }
					},{
						key: 'circulation_value',
						label: '流通',
						sortable: true,
						formatter: (value) => {
							return (value/100000000).toFixed(2);
						}
					},
				],
			};
		},
		components: {
			// StockTextPopularItem,
			// Navbar
		},
		mounted() {
			this.refresh_popular();
			
			this.timer = setInterval(() => {  //创建定时器
				this.refresh_intervel();
			}, 10000);
		},
		methods: {
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			onDatePicked(event){
				// console.log(ctx.selectedYMD);
				this.$emit('date-selected', event.selectedYMD);
				this.refresh_popular();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()
				
				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if(weekday === 0 || weekday === 6){
					return true;
				}
				//今天之后不能选
				if(time>=now_time){
					return true;
				}
				return false
			},
			refresh_popular(){
				request_zzquant({
						// url: 'stock/d/popular/' + this.date1
						url:'/market/stocks/king/rank?is_real=1&date2='+this.date1+'&rank_down=200&rank_up=1200'
					})
					.then(res1 => {
						// console.log(res1['data']['data']);
						this.stocks = res1['data']['data'];
						this.isBusy = false
					})
					.catch(err => {
						console.log(err);
					});
			},
			handleDateSelected(event) {
				this.$emit('date-selected', event.selectedYMD);
			},
			p_show_kline(symbol_code){
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline',symbol_code)
			},
			refresh_intervel(){
				if(Number(this.auto_refresh)){
					let  myDate = new Date();
					let day = myDate.getDay() //获取当前星期X(0-6,0代表星期天)
					let hour = myDate.getHours(); //获取当前小时数(0-23)
					if (0< day && day<6 && 9<=hour && hour<=15){
						this.refresh_popular();
					}else{
						console.log("trend 非交易时间不刷新");
					}
				}
			},
			clearTimer() { //清除定时器
				clearInterval(this.timer);
				this.timer = null;
			},
			getGradientColor(start_color, end_color, percent) {
				// strip the leading # if it's there
				start_color = start_color.replace(/^\s*#|\s*$/g, '');
				end_color = end_color.replace(/^\s*#|\s*$/g, '');
			
				// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
				if (start_color.length == 3) {
					start_color = start_color.replace(/(.)/g, '$1$1');
				}
			
				if (end_color.length == 3) {
					end_color = end_color.replace(/(.)/g, '$1$1');
				}
			
				// get colors
				function parse(rgb, i) {
					return parseInt(rgb.substr(i, 2), 16)
				}
			
				let start_r = parse(start_color, 0),
					start_g = parse(start_color, 2),
					start_b = parse(start_color, 4);
			
				let end_r = parse(end_color, 0),
					end_g = parse(end_color, 2),
					end_b = parse(end_color, 4);
			
				// calculate new color
				let r = end_r - start_r;
				let g = end_g - start_g;
				let b = end_b - start_b;
			
				r = ((r * percent) + start_r)
				g = ((g * percent) + start_g)
				b = ((b * percent) + start_b)
			
				function hex(x) {
					let h = x.toString(16).split('.')[0].toUpperCase()
					return (h.length == 1) ? '0' + h : h
				}
			
				return '#' + hex(r) + hex(g) + hex(b)
			},
			
			getPercentColor(pt) {
				if (pt >= 0) {
					if (pt > +10) {
						pt = +10;
					}
					pt = +pt / 10;
					return this.getGradientColor('#FFFFFF', '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10;
					}
					pt = -pt / 10;
					return this.getGradientColor('#FFFFFF', '#278B22', pt)
				}
			},getPercentStyle(pt) {
				return {
					'background': this.getPercentColor(pt)
				}
			},
		}
	};
</script>

<style>
	
</style>
